
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../../hooks/useMounted';
import { IsModemAccess } from '../../../helpers/Helper';


import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../../helpers/api_helper';
import { POST_GET_PLAN_DETAIL, POST_ADD_EDIT_PLAN } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';

const Setting = (props) => {
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ planId: 0, name: '', code: '', price: '', freeDay: 0,  userNote : '' });
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            if (id) {
                if (!IsModemAccess('subscription_plan', 'edit')) {
                    toast.error('Does not permission this module');
                    navigate("/admin/dashboard");
                }
                var res_data = await post(POST_GET_PLAN_DETAIL, { 'planId': id });
                if (res_data.status) {
                    setInputs(res_data.data.detail);
                } else {
                    toast.error(res_data.message);
                    navigate("/admin/dashboard");
                }
            } else {
                if (!IsModemAccess('subscription_plan', 'add')) {
                    toast.error('Does not permission this module');
                    navigate("/admin/dashboard");
                }
            }
            setLoader(1)
        }

        get_detaile();
    }, [])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_PLAN, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                navigate("/admin/subscription-plan");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if(event.target.name === 'updatePlanSubscribersAsWell'){
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: (event.target.checked) ? true : false }));
        }else{
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }

    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">Subscription Plan</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Name *</label>
                                    <input name="name" value={form_inputs.name} onChange={handleInputChange} className="form-control" placeholder="Enter Name" type="text" />
                                    {simpleValidator.current.message('name', form_inputs.name, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Code *</label>
                                    <input name="code" value={form_inputs.code} onChange={handleInputChange} className="form-control" placeholder="Enter Code" type="text" />
                                    {simpleValidator.current.message('code', form_inputs.code, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Price *</label>
                                    <input name="price" value={form_inputs.price} onChange={handleInputChange} className="form-control" placeholder="Enter price" type="text" />
                                    {simpleValidator.current.message('price', form_inputs.price, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Free Day *</label>
                                    <input name="freeDay" value={form_inputs.freeDay} onChange={handleInputChange} className="form-control" placeholder="Enter free day" type="text" />
                                    {simpleValidator.current.message('free day', form_inputs.freeDay, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Credit *</label>
                                    <input name="chequePrint" value={form_inputs.chequePrint} onChange={handleInputChange} className="form-control" placeholder="Enter credit" type="text" />
                                    {simpleValidator.current.message('Credit', form_inputs.chequePrint, 'required')}
                                </div>

                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Save
                                    </button>
                                    <Link to="/admin/subscription-plan" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Setting;